<template lang="html">
  <RowContent 
    :model="model" 
    :fullName="teamName"
  />
</template>

<script>
import RowContent from '@/components/responses/RowContent.vue'

export default {
  name: 'process-responses-row',

  props: {
    model: Object
  },

  components: {
    RowContent
  },

  computed: {
    batChampionship () {
      return this.model ? this.model['bat-championship'] : null
    },

    // storeResponseDataBatChampionship lives in mixin
    teamName () {
      return this.batChampionship ? this.batChampionship.team_name : null
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
